<script lang="ts">
    import {onMount} from "svelte";

    let dots:string = $state('...');

    function change_dots() {
        if (dots.length > 3) {
            dots = '';
        } else {
            dots += '.';
        }
        console.log(dots);
    }

    onMount(() => {
        const interval = setInterval(() => {
            change_dots();
        }, 500);

        return () => clearInterval(interval);
    });
</script>

<div class="loading">
    <span>
    Zoekmachine laden{dots}
    </span>
</div>

<style lang="scss">
    .loading {
      color: #1F4588;
        font-size: 1.5rem;
    }
</style>


